import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="benefits-grid">
          <div className="benefits-left">
            <div className="eyebrow">Why Enteranet</div>
            <h2>Infrastructure That Works — and Keeps Working</h2>
            <p>{props.data ? props.data.paragraph : "loading..."}</p>
          </div>
          <div className="benefits-right">
            {props.data && props.data.benefits
              ? props.data.benefits.map((b, i) => (
                  <div key={i} className="benefit-item">
                    <div className="benefit-accent"></div>
                    <div className="benefit-content">
                      <h4>{b.title}</h4>
                      <p>{b.text}</p>
                    </div>
                  </div>
                ))
              : "loading"}
          </div>
        </div>
      </div>
    </div>
  );
};
